import { getWebRoot, dxpOpenMenu } from '@/utils/utils';

export default {
  checkUndefined() {
    if (!window.portal) window.portal = {};
    if (!window.portal.appGlobal) window.portal.appGlobal = {};
    if (!window.portal.appGlobal.attributes) window.portal.appGlobal.attributes = {};
  },

  attributesModify(preData, data) {
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (value) preData[key] = value;
    });
    return preData;
  },

  // 登陆前 设置window.portal.appGlobal.attributes.language信息
  setLanguage(key) {
    this.checkUndefined();
    // 业务产品存在这样的用法：const portalLan = global.portal.appGlobal.attributes.language;
    window.portal.appGlobal.attributes.language = key;
  },

  // 登陆后 设置window.portal.AppGlobal信息
  setAppGlobal(data) {
    this.checkUndefined();
    const preData = window.portal.appGlobal.attributes;
    window.portal.appGlobal.attributes = this.attributesModify(preData, data);
    window.portal.appGlobal.get = key => window.portal.appGlobal.attributes[key];

    if (data._csrf) {
      const { token, headerName, parameterName } = data._csrf;
      window.portal.appGlobal.attributes._csrf = token;
      window.portal.appGlobal.attributes._csrf_header = headerName;
      window.portal.appGlobal.attributes._csrf_parameterName = parameterName;
    }

    window.portal.appGlobal.attributes.webroot = getWebRoot();

    this.setDefaultUrl('/');

    // 抛出全局对象portal：登录状态logonStatus/打开菜单方法openMenu
    window.portal.dxpOpenMenu = dxpOpenMenu;
  },

  // 设置window.portal.appGlobal.attributes.spId信息
  setSpId(key) {
    window.portal.appGlobal.attributes.spId = key;
  },

  // 设置window.portal.defaultUrl信息
  setDefaultUrl(key) {
    window.portal.defaultUrl = key;
  },

  // 获取window.portal.appGlobal.attributes.spId信息
  getSpId() {
    return window.portal.appGlobal.attributes.spId;
  },

  // 获取window.portal.appGlobal.attributes.portalId信息
  getPortalId() {
    return window.portal.appGlobal.attributes.portalId;
  },
};
